import { styled } from '../../Styles/stitches.config'

export const StyledOverviewCard = styled('div', {
    h: '130px',
    w: 'calc(100% - 63px)',
    maxWidth: '300px',
    position: 'relative',
    color: 'white',
})

export const StyledBottomDiv = styled('div', {
    h: '100%',
    w: '100%',
    boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.15)',
    br: '$2 0 0 $2',
    bgc: 'white',
    color: 'white',
})

export const StyledTopDiv = styled('div', {
    position: 'absolute',
    inset: 0,
    background:
        'linear-gradient(90deg, $primary300 0%, $primary300 30%, $primary200 60%, $primary200 90%)',
    border: '1px solid $primary200',
    br: '$2 0 0 $2',
    color: 'white',
})
export const StyledBtn = styled('div', {
    h: '29.5px',
    w: '63px',
    br: '0 $2 $2 0',
    color: '$primary500',
    bgc: '$primary200',
    boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.15)',
    fontWeight: '400',
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    pl: '$1',

    variants: {
        active: {
            true: {
                bgc: 'white',
                zIndex: '$fixed',
                background: '$primary500',
                color: 'white',
                borderTop: '1px solid $primary200',
                borderRight: '1px solid $primary200',
                borderBottom: '1px solid $primary200',
                borderLeft: '1px solid #FBFBFB',
                clipPath: 'inset(-5px -5px -5px 0px)',
            },
            false: {},
        },
    },
})
